import { ProFormSelect } from '@ant-design/pro-components'
import { Checkbox, DatePicker, Form, FormInstance, Input, Modal } from 'antd'
import { useWatch } from 'antd/es/form/Form'
import CustomSelect from 'base/ui/components/CustomSelect'
import { SearchItem } from 'pages/Components/SearchBox'
import React, { useEffect, useState } from 'react'
import CustomButton from 'base/ui/components/Button';
import * as Icon from 'base/ui/components/Icons';
import { FiExternalLink } from "react-icons/fi";
import usePartialState from 'hooks/usePartialState'
import { mock } from './mock'
import ModalCustomer from './ModalCustomer'
import { CommonModel } from 'services/Main/common_services'
import { commonPresenter, commonStore } from 'stores/root_store'
import useDebounce from 'hooks/useDebounce'
import { getSaleOrgCode } from 'utils/localStorageHelper'
import { string } from 'yup'

export const waitTime = (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

type ComponentProps = {
  form: FormInstance<any>
}

const SelectSearch = ({ form }: ComponentProps) => {



  // phân Loại KH
  const [listCustomerType, setListCustomerType] = useState<CommonModel[]>([]);
  // Nguồn KH
  const [listCustomerSource, setListCustomerSource] = useState<CommonModel[]>([]);
  // Phân nhóm KH
  const [listCustomerAccountGroup, setListCustomerAccountGroup] = useState<CommonModel[]>([]);
  // Phân hạng kh
  const [listCustomerRank, setListCustomerRank] = useState<CommonModel[]>([]);
  // công ty
  const [listCompanySaleOrg, setListCompanySaleOrg] = useState<CommonModel[]>([]);
  // Chi nhánhh
  const [listStore, setListStore] = useState<CommonModel[]>([]);
  // Khu vực
  const [listSaleOffice, setListSaleOffice] = useState<CommonModel[]>([]);
  // Tỉnh/ Thành phố
  const [listProvince, setListProvince] = useState<CommonModel[]>([]);
  // Quận / huyện
  const [listDistrict, setListDistrict] = useState<CommonModel[]>([]);
  // Phường xã
  const [listWard, setListWard] = useState<CommonModel[]>([]);
  // Nhóm khách hàng
  const [listCustomerGroup, setListCustomerGroup] = useState<CommonModel[]>([]);
  // Ngành nghề
  const [listCustomerCareer, setListCustomerCareer] = useState<CommonModel[]>([]);
  // Loại địa chỉ
  const [listAddressType, setListAddressType] = useState<CommonModel[]>([]);
  // NV kinh doanh
  const [listSalesEmployee, setListSalesEmployee] = useState<CommonModel[]>([]);
  // NV Admin
  const [listAdminEmployee, setListAdminEmployee] = useState<CommonModel[]>([]);
  // Người tạo
  const [listCreateBy, setListCreateBy] = useState<CommonModel[]>([]);
  // Phòng ban
  const [listDepartment, setListDepartment] = useState<CommonModel[]>([]);

  const [openModal, setOpenModal] = usePartialState({
    isShow: false,
    title: '',
    valueSelect: ''
  })
  const [openModal2, setOpenModal2] = usePartialState({
    isShow: false,
    title: '',
    valueSelect: ''
  })
  // =================================================================================================
  // =================================================================================================
  // =================================================================================================

  const valueSelect: string[] = useWatch('selectSearch', form)


  // phân Loại KH
  const getDataCustomerType = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerType");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerType(commonStore.commonRespone.data);
    }
  };
  // Nguồn KH
  const getDataCustomerSource = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerSource");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerSource(commonStore.commonRespone.data);
    }
  };
  // Phân nhóm KH
  const getDataCustomerAccountGroup = async () => {
    await commonPresenter.getCommonDataByKey(
      commonStore,
      "CustomerAccountGroup"
    );
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerAccountGroup(commonStore.commonRespone.data);
    }
  };
  // Phân hạng kh
  const getDataCustomerRank = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "Customer_Class");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerRank(commonStore.commonRespone.data);
    }
  };
  // Công ty
  const getListSaleOrg = async () => {
    await commonPresenter.getCompanyByAccountHasId(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListCompanySaleOrg(commonStore.commonRespone.data);
    }
  };
  // Chi nhánhh
  const getDataStore = async () => {
    await commonPresenter.getStoreByAccount(commonStore);
    if (commonStore.commonRespone.isSuccess) {
      setListStore(commonStore.commonRespone.data);
    }
  };
  const getDataSaleOffice = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "SaleOffice");
    if (commonStore.commonRespone.isSuccess) {
      setListSaleOffice(commonStore.commonRespone.data);
    }
  };
  // Phường xã
  const getDataWard = async (district?: string[]) => {
    if (district) {
      await commonPresenter.getListWard(commonStore, district);
      if (commonStore.commonRespone.isSuccess) {
        setListWard(commonStore.commonRespone.data);
      }
    } else {
      setListWard([]);
    }
  };
  // Quận / huyện
  const getDataDistrict = async (province?: string[]) => {
    if (province && Array.isArray(province)) {
      await commonPresenter.getListDistrict(commonStore, province);
      if (commonStore.commonRespone.isSuccess) {
        setListDistrict(commonStore.commonRespone.data);
      }
    } else {
      setListDistrict([]);
    }
  };
  // Tỉnh/ Thành phố
  const getDataProvince = async (area?: string) => {
    await commonPresenter.getListProvince(commonStore, area);
    if (commonStore.commonRespone.isSuccess) {
      setListProvince(commonStore.commonRespone.data);
    }
  };
  // Nhóm khách hàng
  const getDataCustomerGroup = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerGroup");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerGroup(commonStore.commonRespone.data);
    }
  };
  // Ngành nghề
  const getDataCustomerCareer = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "CustomerCareer");
    if (commonStore.commonRespone.isSuccess) {
      setListCustomerCareer(commonStore.commonRespone.data);
    }
  };
  // Loại địa chỉ
  const getDataAddressType = async () => {
    await commonPresenter.getCommonDataByKey(commonStore, "AddressType");
    if (commonStore.commonRespone.isSuccess) {
      setListAddressType(commonStore.commonRespone.data);
    }
  };
  // Phòng ban
  const getDataDepartment = async (key?: string) => {
    await commonPresenter.getListDepartment(commonStore, key, getSaleOrgCode());
    if (commonStore.commonRespone.isSuccess) {
      setListDepartment(commonStore.commonRespone.data);
    }
  };
  const getDataSalesEmployee = async (
    type: "NVKD" | "NVAD" | "CREATE",
    key?: string
  ) => {
    await commonPresenter.getListPersonInCharge(commonStore, key);
    if (commonStore.commonRespone.isSuccess) {
      switch (type) {
        case "NVKD":
          setListSalesEmployee(commonStore.commonRespone.data);
          break;
        case "NVAD":
          setListAdminEmployee(commonStore.commonRespone.data);
          break;
        case "CREATE":
          setListCreateBy(commonStore.commonRespone.data);
          break;
      }
    }
  };
  const searchSalesEmployee = useDebounce(getDataSalesEmployee, 300);
  const status = [
    {
      value: true,
      label: 'Đang sử dụng',
    },
    {
      value: false,
      label: 'Ngưng sử dụng',
    },
  ];
  // =================================================================================================================
  // =================================================================================================================
  // =================================================================================================================


  // Function close modal
  const handleCancel = () => {
    setOpenModal({
      isShow: false,
      title: ''
    });
  };
  // Function close modal
  const handleCancelModal2 = () => {
    setOpenModal2({
      isShow: false,
      title: ''
    });
  };

  const handleSelectCustomer = (profile: string, profileId: string) => {
    handleCancelModal2()
    form.setFieldValue('profileId', profileId)
    form.setFieldValue('profileNameKH', profile)
  }


  const handleConfirm = () => {
    const valueTempt = openModal.valueSelect === 'Có dữ liệu' ? 'Có dữ liệu' : openModal.valueSelect === 'Tùy chỉnh' ? 'Tùy chỉnh' : 'Không có dữ liệu'
    switch (openModal.title) {
      case 'Mã SAP':
        form.setFieldValue('profileForeignCode', valueTempt)
        break;
      case 'Địa chỉ':
        form.setFieldValue('address', valueTempt)
        break;
      case 'Mã số thuế':
        form.setFieldValue('taxNo', valueTempt)
        break;
      case 'Nguồn khách hàng':
        form.setFieldValue('customerSourceCodeIsNull', valueTempt)
        break;
      case 'Phân loại khách hàng':
        form.setFieldValue('customerTypeCodeIsNull', valueTempt)
        break;
      case 'Tỉnh/Thành phố':
        form.setFieldValue('provinceIdIsNull', valueTempt)
        break;
      case 'Quận/Huyện':
        form.setFieldValue('districtIdIsNull', valueTempt)
        break;
      case 'Phường/Xã':
        form.setFieldValue('wardIdIsNull', valueTempt)
        break;
      case 'Ngành nghề':
        form.setFieldValue('customerCareerCodeIsNull', valueTempt)
        break;
      case 'NV kinh doanh':
        form.setFieldValue('salesEmployeeCodeIsNull', valueTempt)
        break;
      case 'Nhóm khách hàng':
        form.setFieldValue('customerGroupCodeIsNull', valueTempt)
        break;
      case 'Email':
        form.setFieldValue('email', valueTempt)
        break;
      default:
        break;
    }
    setOpenModal({ valueSelect: '' })
    setOpenModal({
      isShow: false,
      title: ''
    });
  };

  useEffect(() => {
    getDataCustomerAccountGroup();
    getDataCustomerRank();
    getDataCustomerSource();
    getDataCustomerType();
    getListSaleOrg();
    getDataStore();

    getDataDepartment()

    getDataSaleOffice();
    getDataWard();
    getDataDistrict()
    getDataProvince()
    getDataCustomerGroup()
    getDataCustomerCareer()

    getDataAddressType()
  }, [])

  return (
    <>
      <div className='col-span-2 flex items-center justify-center gap-1 px-10'>
        {/* Select */}
        <Form.Item className='!w-full' label={' '}>
          <ProFormSelect
            showSearch
            name={'selectSearch'}
            fieldProps={{
              // filterOption: false
              mode: 'multiple',
              size: 'middle'
            }}
            debounceTime={300}
            // rules={[
            //   {
            //     required: true,
            //     message: 'Please select!',
            //     type: 'array',
            //   },
            // ]}
            request={async ({ keyWords }, props) => {
              // return await commonPresenter.getListCustomerHasId(commonStore, keyWords).then((data) => {

              //   return data.map((i: CommonModel) => ({
              //     label: `${i.value}`,
              //     value: i.key || '',
              //   })) || []
              // })
              await waitTime(100);
              return mock
            }}
          />
        </Form.Item>
        {/* Check all */}
        <SearchItem label={' '} name={'checkAll'} valuePropName='checked'>
          <Checkbox className='' onChange={(e) => {
            if (e.target.checked) {
              const allData = mock.map(item => item.value)
              form.setFieldValue('selectSearch', allData)
            } else {
              form.setFieldValue('selectSearch', undefined)
            }
          }} />
        </SearchItem>
      </div>
      {/* Mã */}
      <SearchItem label={'Mã'} name={'profileCode'}>
        <Input />
      </SearchItem>
      {/* Mã Sap */}
      <div className='flex gap-1'>
        <Form.Item
          label={
            <p className="font-semibold whitespace-pre-line">Mã SAP</p>
          }
          className='!w-full' name={'profileForeignCode'}>
          <Input disabled={form.getFieldValue('profileForeignCode') === 'Có dữ liệu' || form.getFieldValue('profileForeignCode') === 'Không có dữ liệu'} />
        </Form.Item>
        <SearchItem label={' '} name={'external'}>
          <CustomButton
            onClick={() => {
              setOpenModal({ isShow: true, title: 'Mã SAP', valueSelect: form.getFieldValue('profileForeignCode') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('profileForeignCode') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
            }}
            icon={<FiExternalLink className='text-[#4c86db]' />}
          />
        </SearchItem>
      </div>
      {/* Tên */}
      <SearchItem label={'Tên'} name={'profileName'}>
        <Input />
      </SearchItem>
      {/* SĐT liên hệ */}
      <SearchItem label={'SĐT liên hệ'} name={'phone'}>
        <Input />
      </SearchItem>
      {/* Phân loại KH */}
      {
        valueSelect?.includes('customerTypeCode') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={
              <p className="font-semibold whitespace-pre-line">Phân loại khách hàng</p>
            }
              name={'customerTypeCode'}>
              <CustomSelect
                allowClear
                options={listCustomerType}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{ label: "value", value: "key" }}
              />
            </Form.Item >
            < Form.Item hidden name={'customerTypeCodeIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Phân loại khách hàng', valueSelect: form.getFieldValue('customerTypeCodeIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('customerTypeCodeIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>
        )
      }
      {/* Nguồn khách hàng */}
      {
        valueSelect?.includes('customerSourceCode') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={
              <p className="font-semibold whitespace-pre-line">Nguồn khách hàng</p>
            }
              name={'customerSourceCode'}>
              <CustomSelect
                allowClear
                options={listCustomerSource}
                fieldNames={{ label: "value", value: "key" }}
              />
            </Form.Item >
            < Form.Item hidden name={'customerSourceCodeIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Nguồn khách hàng', valueSelect: form.getFieldValue('customerSourceCodeIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('customerSourceCodeIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>
        )
      }
      {/* Công ty */}
      {
        valueSelect?.includes('companyId') && (
          < SearchItem label={'Công ty'} name={'companyId'}>
            <CustomSelect
              options={listCompanySaleOrg}
              fieldNames={{ label: "value", value: "key" }}
              allowClear
              showSearch
              filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
            />
          </SearchItem >
        )
      }
      {/* Chi nhánh */}
      {
        valueSelect?.includes('storeId') && (
          < SearchItem label={'Chi nhánh'} name={'storeId'}>
            <CustomSelect
              options={listStore}
              selectAll
              mode="multiple"
              allowClear
              fieldNames={{ label: "value", value: "key" }}
              showSearch
              filterOption={(input, option) =>
                (option?.value ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </SearchItem >
        )
      }
      {/* Phân nhóm khách hàng */}
      {
        valueSelect?.includes('customerAccountGroupCode') && (
          < SearchItem label={'Phân nhóm khách hàng'} name={'customerAccountGroupCode'}>
            <CustomSelect
              options={listCustomerAccountGroup}
              mode="multiple"
              allowClear
              fieldNames={{ label: "value", value: "key" }}
              showSearch
              filterOption={(input, option) =>
                (option?.value ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </SearchItem >
        )
      }
      {/* Khách hàng */}
      <SearchItem start label={'Khách hàng'} name={'profileNameKH'}>
        <Input readOnly addonAfter={
          <div onClick={() => { setOpenModal2({ isShow: true }) }} className='text-lg font-bold cursor-pointer'>...</div>
        } />
      </SearchItem>
      <SearchItem hidden label={'Khách hàng'} name={'profileId'}>
        <Input />
      </SearchItem>
      {/* Khu vực */}
      {
        valueSelect?.includes('saleOfficeCode') && (
          < SearchItem start label={'Khu vực'} name={'saleOfficeCode'}>
            <CustomSelect
              mode='multiple'
              options={listSaleOffice}
              filterOption={(input, option) =>
                (option?.value ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              fieldNames={{ label: "value", value: "key" }}
              showSearch
              allowClear
            />
          </SearchItem >
        )
      }
      {/* Tỉnh/Thành phố */}
      {
        valueSelect?.includes('provinceId') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'Tỉnh/Thành phố'} name={'provinceId'}>
              <CustomSelect
                // mode="multiple"
                options={listProvince}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </Form.Item >
            < Form.Item hidden name={'provinceIdIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Tỉnh/Thành phố', valueSelect: form.getFieldValue('provinceIdIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('provinceIdIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>

        )
      }
      {/* Quận/Huyện */}
      {
        valueSelect?.includes('districtId') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'Quận/Huyện'} name={'districtId'}>
              <CustomSelect
                mode="multiple"
                options={listDistrict}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </Form.Item >
            < Form.Item hidden name={'districtIdIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Quận/Huyện', valueSelect: form.getFieldValue('districtIdIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('districtIdIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>

        )
      }
      {/* Phường xã */}
      {
        valueSelect?.includes('wardId') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'Phường xã'} name={'wardId'}>
              <CustomSelect
                mode="multiple"
                options={listWard}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                showSearch
                allowClear
              />
            </Form.Item >
            < Form.Item hidden name={'wardIdIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Phường/Xã', valueSelect: form.getFieldValue('wardIdIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('wardIdIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>

        )
      }
      {/* Loại địa chỉ */}
      {
        valueSelect?.includes('addressTypeCode') && (
          <>
            < SearchItem label={'Loại địa chỉ'} name={'addressTypeCode'}>
              <CustomSelect
                options={listAddressType}
                mode='multiple'
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </SearchItem >
            < SearchItem label={'Xem tất cả loại địa chỉ'} valuePropName='checked' name={'isMainAddressTypeCode'}>
              <Checkbox />
            </SearchItem >
          </>
        )
      }
      {/* địa chỉ */}
      <div className='flex gap-1'>
        <Form.Item
          label={
            <p className="font-semibold whitespace-pre-line">Địa chỉ</p>
          }
          className='!w-full' name={'address'}>
          <Input disabled={form.getFieldValue('address') === 'Có dữ liệu' || form.getFieldValue('address') === 'Không có dữ liệu'} />
        </Form.Item>
        <SearchItem label={' '} name={'external'}>
          <CustomButton
            onClick={() => {
              setOpenModal({ isShow: true, title: 'Địa chỉ', valueSelect: form.getFieldValue('address') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('address') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
            }}
            icon={<FiExternalLink className='text-[#4c86db]' />}
          />
        </SearchItem>
      </div>
      {/* Nhóm khách hàng */}
      {
        valueSelect?.includes('customerGroupCode') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'Nhóm khách hàng'} name={'customerGroupCode'}>
              <CustomSelect
                options={listCustomerGroup}
                mode='multiple'
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </Form.Item >
            < Form.Item hidden name={'customerGroupCodeIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Nhóm khách hàng', valueSelect: form.getFieldValue('customerGroupCodeIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('customerGroupCodeIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>

        )
      }
      {/* Ngành nghề */}
      {
        valueSelect?.includes('customerCareerCode') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'Ngành nghề'} name={'customerCareerCode'}>
              <CustomSelect
                mode='multiple'
                // kiểm tra nếu TC01.2 Phân loại khách hàng đang được pick value là tiêu dùng thì disable
                options={listCustomerCareer}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                allowClear
                showSearch
              />
            </Form.Item >
            < Form.Item hidden name={'customerCareerCodeIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Ngành nghề', valueSelect: form.getFieldValue('customerCareerCodeIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('customerCareerCodeIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>
        )
      }
      {/* NV kinh doanh */}
      {
        valueSelect?.includes('salesEmployeeCode') && (
          <div className='flex gap-1'>
            < Form.Item className='w-full' label={'NV kinh doanh'} name={'salesEmployeeCode'}>
              <CustomSelect
                mode='multiple'
                options={listSalesEmployee}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={false}
                onSearch={async (value) => searchSalesEmployee("NVKD", value)}
                showSearch
                allowClear
              />
            </Form.Item >
            < Form.Item hidden name={'salesEmployeeCodeIsNull'}><Input /></Form.Item>
            <SearchItem label={' '}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'NV kinh doanh', valueSelect: form.getFieldValue('salesEmployeeCodeIsNull') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('salesEmployeeCodeIsNull') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>
        )
      }
      {/* Phòng ban NV phụ trách */}
      {
        valueSelect?.includes('rolesCode') && (
          < SearchItem label={'Phòng ban NV phụ trách'} name={'rolesCode'}>
            <CustomSelect
              mode='multiple'
              options={listDepartment}
              fieldNames={{ label: "value", value: "key" }}
              filterOption={(input, option) =>
                (option?.value ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              allowClear
              showSearch
            />
          </SearchItem >
        )
      }
      {/* Nhân viên TVVL */}
      {
        valueSelect?.includes('personInCharge6Code') && (
          < SearchItem label={'Nhân viên TVVL'} name={'personInCharge6Code'}>
            <CustomSelect options={[]} />
          </SearchItem >
        )
      }
      {/* Mã số thuế */}
      <div className='flex gap-1'>
        <Form.Item
          label={
            <p className="font-semibold whitespace-pre-line">Mã số thuế</p>
          }
          className='!w-full' name={'taxNo'}>
          <Input disabled={form.getFieldValue('taxNo') === 'Có dữ liệu' || form.getFieldValue('taxNo') === 'Không có dữ liệu'} />
        </Form.Item>
        <SearchItem label={' '} name={'external'}>
          <CustomButton
            onClick={() => {
              setOpenModal({ isShow: true, title: 'Mã số thuế', valueSelect: form.getFieldValue('taxNo') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('taxNo') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
            }}
            icon={<FiExternalLink className='text-[#4c86db]' />}
          />
        </SearchItem>
      </div>
      {/* NV Admin */}
      {
        valueSelect?.includes('adminEmployee') && (
          <>
            < SearchItem start label={'NV Admin'} name={'adminEmployee'}>
              <CustomSelect
                options={listAdminEmployee}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={false}
                onSearch={async (value) => searchSalesEmployee("NVAD", value)}
                showSearch
                allowClear
              />
            </SearchItem >
          </>
        )
      }
      {/* Phân hạng KH */}
      {
        valueSelect?.includes('phanHang') && (
          <>
            < SearchItem start label={'Phân hạng KH'} name={'phanHang'}>
              <CustomSelect
                options={listCustomerRank}
                fieldNames={{ label: "value", value: "key" }}
                allowClear
              />
            </SearchItem >
          </>
        )
      }
      {/* Trạng thái */}
      {
        valueSelect?.includes('actived') && (
          < SearchItem label={'Trạng thái'} name={'actived'}>
            <CustomSelect
              options={status}
              allowClear
            />
          </SearchItem >
        )
      }
      {/* Ngày tạo */}
      {
        valueSelect?.includes('ngaytao') && (
          <>
            < SearchItem start label={'Ngày tạo từ'} name={'createFromDate'}>
              <DatePicker className='!w-full' />
            </SearchItem >
            < SearchItem label={'Ngày tạo đến'} name={'createToDate'}>
              <DatePicker className='!w-full' />
            </SearchItem >
          </>
        )
      }
      {/* Email */}
      {
        valueSelect?.includes('email') && (
          <div className='flex gap-1'>
            <Form.Item
              label={
                <p className="font-semibold whitespace-pre-line">Email</p>
              }
              className='!w-full' name={'email'}>
              <Input disabled={form.getFieldValue('email') === 'Có dữ liệu' || form.getFieldValue('email') === 'Không có dữ liệu'} />
            </Form.Item>
            <SearchItem label={' '} name={'external'}>
              <CustomButton
                onClick={() => {
                  setOpenModal({ isShow: true, title: 'Email', valueSelect: form.getFieldValue('email') === 'Có dữ liệu' ? 'Có dữ liệu' : form.getFieldValue('email') === 'Không có dữ liệu' ? 'Không có dữ liệu' : 'Tùy chỉnh' })
                }}
                icon={<FiExternalLink className='text-[#4c86db]' />}
              />
            </SearchItem>
          </div>
        )
      }
      {/* Người tạo */}
      {
        valueSelect?.includes('createByCode') && (
          <>
            < SearchItem start label={'Người tạo'} name={'createByCode'}>
              <CustomSelect
                options={listCreateBy}
                fieldNames={{ label: "value", value: "key" }}
                filterOption={false}
                onSearch={async (value) =>
                  searchSalesEmployee("CREATE", value)
                }
                showSearch
                allowClear
              />
            </SearchItem >
          </>
        )
      }
      {/* Yêu cầu tạo */}
      {
        valueSelect?.includes('yeucautao') && (
          <>
            < SearchItem start label={'Yêu cầu tạo từ'} name={'createRequestTimeFrom'}>
              <DatePicker className='!w-full' />
            </SearchItem >
            < SearchItem label={'Yêu cầu tạo đến'} name={'createRequestTimeTo'}>
              <DatePicker className='!w-full' />
            </SearchItem >
          </>
        )
      }

      <Modal
        title={
          <h1 className="text-[18px] uppercase">{openModal.title}</h1>
        }
        open={openModal.isShow}
        okText="Lưu"
        cancelText="Đóng"
        onOk={handleConfirm}
        onCancel={handleCancel}
      >
        <div className='flex gap-3 items-center'>
          <div className='font-bold text-default whitespace-nowrap'>Dữ liệu</div>
          <CustomSelect value={openModal.valueSelect}
            onChange={(value, option) => {
              setOpenModal({ valueSelect: option.value })
            }}
            options={[
              { value: 'Tùy chỉnh', label: 'Tùy chỉnh' },
              { value: 'Có dữ liệu', label: 'Có dữ liệu' },
              { value: 'Không có dữ liệu', label: 'Không có dữ liệu' },
            ]} className='!w-full' />
        </div>
      </Modal>

      <Modal
        title={
          <h1 className="text-[18px] uppercase">{openModal2.title}</h1>
        }
        style={{ top: 20 }}
        className="min-w-[70%] w-full !p-0"
        open={openModal2.isShow}
        okButtonProps={{
          hidden: true
        }}
        cancelButtonProps={{
          hidden: true
        }}
        onCancel={handleCancelModal2}
      >
        <ModalCustomer handleSelectCustomer={handleSelectCustomer} />
      </Modal >
    </>
  )
}

export default SelectSearch